// api.js - Централизованный API клиент для приложения
import axios from '../axiosConfig';
import { handleError } from './ErrorHandler';

// Функция для инициализации API с использованием навигации
let navigate = null;

export const initApi = (navigateFunction) => {
  navigate = navigateFunction;
};

/**
 * Обертка для GET запросов с обработкой ошибок
 * @param {string} url - URL-адрес для запроса
 * @param {object} config - Дополнительные настройки запроса
 * @returns {Promise<any>} - Результат запроса
 */
export const get = async (url, config = {}) => {
  try {
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    if (navigate) {
      handleError(error, navigate);
    }
    throw error;
  }
};

/**
 * Обертка для POST запросов с обработкой ошибок
 * @param {string} url - URL-адрес для запроса
 * @param {object} data - Данные для отправки
 * @param {object} config - Дополнительные настройки запроса
 * @returns {Promise<any>} - Результат запроса
 */
export const post = async (url, data = {}, config = {}) => {
  try {
    const response = await axios.post(url, data, config);
    return response.data;
  } catch (error) {
    if (navigate) {
      handleError(error, navigate);
    }
    throw error;
  }
};

/**
 * Обертка для PUT запросов с обработкой ошибок
 * @param {string} url - URL-адрес для запроса
 * @param {object} data - Данные для отправки
 * @param {object} config - Дополнительные настройки запроса
 * @returns {Promise<any>} - Результат запроса
 */
export const put = async (url, data = {}, config = {}) => {
  try {
    const response = await axios.put(url, data, config);
    return response.data;
  } catch (error) {
    if (navigate) {
      handleError(error, navigate);
    }
    throw error;
  }
};

/**
 * Обертка для DELETE запросов с обработкой ошибок
 * @param {string} url - URL-адрес для запроса
 * @param {object} config - Дополнительные настройки запроса
 * @returns {Promise<any>} - Результат запроса
 */
export const del = async (url, config = {}) => {
  try {
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    if (navigate) {
      handleError(error, navigate);
    }
    throw error;
  }
};

// Простой вызов для быстрой проверки страницы ошибки
export const testErrorPage = (statusCode = 500) => {
  if (navigate) {
    navigate(`/error/${statusCode}`);
  } else {
    console.error('API not initialized with navigate function');
  }
};

const api = {
  get,
  post,
  put,
  delete: del,
  axios, // Экспортируем сам экземпляр axios для случаев, когда нужны особые запросы
  initApi,
  testErrorPage
};
export default api; 